module.exports = __webpack_public_path__ + "static/media/icon-shield.617cc3f7.svg";